import React, { useEffect } from "react";
import ReferralMembersTable from "../../components/Tree/ReferralMembersTable";
import { useState } from "react";
import TreeViewNavbar from "../../components/Tree/TreeViewNavbar";
import { useSelector } from "react-redux";
import { getUserDefaultPlan } from "../../utils/defaultPlan";

function ReferralMembers() {
  const [currentPage, setCurrentPage] = useState(1);
  const [treePlan, setTreePlan] = useState(null);
  const userPlans = useSelector((state) => {
    return state.dashboard?.appLayout?.userplans;
  });
  const userDefaultPlan = getUserDefaultPlan();

  useEffect(() => {
    if (userDefaultPlan) {
      setTreePlan(userDefaultPlan);
    } else if (userPlans?.defaultPlan) {
      setTreePlan(userPlans.defaultPlan);
    }
  }, [userPlans, userDefaultPlan]);

  return (
    <>
      {treePlan &&
        <>
          <TreeViewNavbar menu={"referralMembers"} treePlan={treePlan} setTreePlan={setTreePlan} />
          <ReferralMembersTable
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            treePlan={treePlan}
          />

        </>
      }
    </>
  );
}

export default ReferralMembers;
